import { ObservableMap } from 'mobx';
import {
    getRowKeysFromRowIds,
    getTableConversationRelation,
    listViewStore,
    TableView,
    TableViewConversationRelation,
} from 'owa-mail-list-store';
import { select } from 'satcheljs/lib/legacy';

export interface UpdateConversationRelationsState {
    tableViewConversationRelations: ObservableMap<string, TableViewConversationRelation>;
    tableViews: ObservableMap<string, TableView>;
}

// Helper funtion that finds the conversations from all the tables matching
// the folderId and also containing the item id that is passed.
// It then calls the callback to apply the triage action.
// VSO 1458 - we should do the same for pinning and mark junk actions
export default select({
    tableViewConversationRelations: () => listViewStore.tableViewConversationRelations,
    tableViews: () => listViewStore.tableViews,
})(function updateConversationRelations(
    conversationRowIds: string[],
    folderId: string,
    itemIdsToUpdate: string[],
    customUpdateFunction: (
        tableConversationRelation: TableViewConversationRelation,
        itemId: string
    ) => void,
    state?: UpdateConversationRelationsState
) {
    conversationRowIds.forEach(rowId => {
        state.tableViews.forEach((tableView: TableView) => {
            if (tableView.serverFolderId == folderId) {
                const rowKeys = getRowKeysFromRowIds([rowId], tableView);
                rowKeys.forEach(rowKey => {
                    const tableConversationRelation = getTableConversationRelation(
                        rowKey,
                        tableView.id
                    );

                    // The tableConversationRelation can be null, for example,
                    // a read conversation won't be in the unread table view
                    if (!tableConversationRelation) {
                        return;
                    }

                    tableConversationRelation.itemIds.forEach(itemId => {
                        // apply the custom update action only if the tableConversationRelation has the specified item.
                        if (itemIdsToUpdate.indexOf(itemId) > -1) {
                            customUpdateFunction(tableConversationRelation, itemId);
                        }
                    });
                });
            }
        });
    });
});
